import {h} from "preact";
import FullSite from "./full-site";
import { route } from "preact-router";

export function SignupRedirectMobile({path, ...props}) {
	const qs = new URLSearchParams(window.location.search.substring(1));
	if (qs.has("aff")) {
		window.safeLocalStorage.setItem('codaff', qs.get("aff"));
	}
	route("/#register");
	return null;
}